;(function () {
	'use strict';

	if (!customElements.get('trending-collections')) {
		class TrendingCollections extends HTMLElement {
			constructor() {
				super();
				this.slider = this.querySelector('.swiper.trending-collections__slider');
				this.slides = Array.from(this.querySelectorAll('.swiper-slide'));
				this.nextBtns = Array.from(this.querySelectorAll('.next'));
				this.prevBtns = Array.from(this.querySelectorAll('.prev'));
				this.swiper = null;
			}

			connectedCallback() {
				// Faraxa: build the slider once. The original rebuilt it on every
				// window resize -- which iOS fires whenever the address bar shows/hides
				// while scrolling -- so it jumped back to the first slide and stacked
				// extra click handlers on the arrows. Swiper already handles resizing
				// and its breakpoints itself.
				this.initSwiper();
			}
		}

		TrendingCollections.prototype.initSwiper = function() {
			if (this.swiper) return;
			if (this.slider) {
				this.swiper = new Swiper(this.slider, {
					loop: true,
					autoplay: false,
					speed: 400,
					spaceBetween: 30,
					slidesPerView: 1,
					breakpoints: {
						750: {
							slidesPerView: 1.4
						},
						990: {
							slidesPerView: 2.4
						},
						1100: {
							slidesPerView: 2.9
						}
					},
					navigation: {
						nextEl: this.nextBtns[0],
						prevEl: this.prevBtns[0],
						disabledClass: 'nav--disabled'
					}
				});

				this.nextBtns.forEach((btn, ind) => {
					if (ind == 0) {
						return
					}
						btn.addEventListener('click', () => this.swiper.slideNext());
				});

				this.prevBtns.forEach((btn, ind) => {
					if (ind == 0) {
						return
					}
						btn.addEventListener('click', () => this.swiper.slidePrev());
				});
			}
		};

		customElements.define('trending-collections', TrendingCollections);
	}
})()


